module.exports = __webpack_public_path__ + "img/palmas-pool-3.7d7af7de.jpg";